
import { useState, useEffect, useRef } from 'react';
import { fetchChargersInBounds } from '../services/nobilService';
import { ChargingStation, Coordinates, MapBounds } from '../types';
import { boundsOverlapRatio } from '../utils/boundsUtils';

export const useChargingStations = (
  active: boolean,
  zoom: number,
  currentViewBounds: MapBounds | null
) => {
  const [chargers, setChargers] = useState<ChargingStation[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const lastFetchedBoundsRef = useRef<MapBounds | null>(null);

  useEffect(() => {
    if (!active || zoom < 9 || !currentViewBounds) {
      if (!active) { setChargers([]); setError(false); lastFetchedBoundsRef.current = null; }
      return;
    }

    if (lastFetchedBoundsRef.current && boundsOverlapRatio(lastFetchedBoundsRef.current, currentViewBounds) > 0.7) {
      return;
    }

    const loadChargers = async () => {
      setIsLoading(true);
      try {
        const data = await fetchChargersInBounds(currentViewBounds);
        setChargers(data);
        setError(false);
        lastFetchedBoundsRef.current = currentViewBounds;
      } catch (err) {
        console.error("Failed to load chargers:", err);
        setError(true);
      } finally {
        setIsLoading(false);
      }
    };

    const timer = setTimeout(loadChargers, 800);
    return () => clearTimeout(timer);
  }, [currentViewBounds, active, zoom]);

  return { chargers, isLoading, error };
};
